import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ol from 'openlayers'
import ReactDOM from 'react-dom'
import { findIndex, isEqual } from 'lodash'
import { connect } from 'react-redux'
import HoverDto from '../../sites/dto/HoverDto'
import SiteTypes from '../../utils/mapUtils/SiteTypes'
import DtoType from '../../referential/dto/DtoSiteType'
import { PANEL_CITY, PANEL_RADIUS } from '../../sites/constants/SitesConstants'
import { DropTarget } from 'react-dnd'
import ItemTypes from '../../components/drag/constants/ItemTypes'
import BoxDustbin from '../../components/drag/components/BoxDustbin'
import LegendDto from '../../administration/dto/LegendDto'
import AppStore from '../../store/AppStore'
import AdministrationAction from '../../administration/actions/AdministrationAction'

// import Popup from './Popup'

class Map extends Component {
	constructor(props) {
		super(props)
		this.state = {
			event: {},
			popup: {
				filters: ['Point', 'Polygon']
			}
		}
		this.moveBox = this.moveBox.bind(this)
		this.removeBox = this.removeBox.bind(this)
		this.clickMap = this.clickMap.bind(this)
	}

	moveBox(id, left, top, content) {
		const boxes = this.props.legends.slice()
		const box = findIndex(boxes, b => b.id === id)
		if (box === -1) {
			boxes.push({ id, content, left, top })
		}
		AppStore.dispatch(AdministrationAction.setLegends(boxes.map(b => {
			if (b.id === id) {
				b.left = left
				b.top = top
			}
			return b
		})))
	}

	removeBox(id) {
		const boxes = this.props.legends.filter(b => b.id !== id)
		AppStore.dispatch(AdministrationAction.setLegends(boxes))
	}

	componentWillMount() {
		const layersTab = this.props.layers.map(el => el.getLayer())
		const map = new ol.Map({
			controls: ol.control.defaults({
				attribution: false
			}).extend([
				new ol.control.ScaleLine()
			]),
			layers: layersTab,
			view: new ol.View({
				//extent: ol.proj.transformExtent([0.882156, 45.296869, 4.087841, 49.069019], 'EPSG:4326', 'EPSG:3857'),
				center: ol.proj.fromLonLat(this.props.mapConf.center),
				zoom: this.props.mapConf.zoom
			})
		})
		this.olMap = map
		this.visualisation = {}
		this.layers = {}
		this.hover = new ol.layer.Vector({
			source: new ol.source.Vector({})
		})
		this.hover.setZIndex(9999)
		this.olMap.addLayer(this.hover)
		//this.setVisualisationsLayers()
		this.olMap.getLayers().forEach(l => {
			const type = l.get('type')
			if (l.get('id') === 'points' && type && type.type) {
				this.layers[type.type] = l
			}
		})
	}

	setVisualisationsLayers() {
		if (this.visualisation.element) {
			this.visualisation.element.remove()
			this.visualisation.element = null
		}
		if (this.visualisation.overlay) {
			this.olMap.removeOverlay(this.visualisation.overlay)
			this.visualisation.overlay = null
		}
		if (this.visualisation.layer) {
			this.olMap.removeLayer(this.visualisation.layer)
			this.visualisation.layer = null
		}
		if (this.visualisation.interaction) {
			this.olMap.removeInteraction(this.visualisation.interaction)
			this.visualisation.interaction = null
		}

		switch (this.props.visualisation) {
			case PANEL_RADIUS:
				this.setState({ popup: { filter: [] } })
				const source = new ol.source.Vector({ wrapX: false })
				const vector = new ol.layer.Vector({
					id: PANEL_RADIUS,
					source: source
				})
				this.olMap.addLayer(vector)
				this.visualisation.layer = vector
				const draw = new ol.interaction.Draw({
					source: source,
					type: 'Circle'
				})
				this.olMap.addInteraction(draw)
				this.visualisation.interaction = draw
				this.listener = ''
				this.visualisation.element = document.createElement('div')
				this.visualisation.element.className = 'tooltip tooltip-measure'
				document.body.prepend(this.visualisation.element)
				const measureTooltip = new ol.Overlay({
					element: this.visualisation.element,
					offset: [0, -15],
					positioning: 'bottom-center'
				})
				this.olMap.addOverlay(measureTooltip)
				this.visualisation.overlay = measureTooltip

				draw.on('drawstart', e => {
					e.feature.getGeometry().on('change', event => {
						const units = this.olMap.getView().getProjection().getUnits()
						this.listener = event.target
						this.visualisation.element.innerHTML = ((this.listener.getRadius() * ol.proj.METERS_PER_UNIT[units]) / 1000).toFixed(2)
						measureTooltip.setPosition(this.listener.getLastCoordinate())
					})
				}, this)
				draw.on('drawend', e => {
					const coord = ol.proj.transform(e.feature.getGeometry().getFirstCoordinate(), 'EPSG:3857', 'EPSG:4326')
					const radius = this.listener.getRadius() / 1000
					this.visualisation.element.innerHTML = ''
					this.props.radius(coord, radius)
					this.setVisualisationsLayers()
				}, this)
				break
			default:
				this.setState({ popup: { filters: ['Point', 'Polygon'] } })
		}
	}

	componentDidMount() {
		const overlay = new ol.Overlay({
			element: document.getElementById('popup-container'),
			positioning: 'bottom-center',
			offset: [0, -10]
		})
		this.overlay = overlay
		this.olMap.addOverlay(overlay)

		this.olMap.on('click', e => {
			overlay.setPosition()
			const features = []
			this.olMap.forEachFeatureAtPixel(e.pixel, f => {
				features.push(f)
			})
			const featuresByType = features.filter(p => p.I.name && (p.I.name.id || p.I.id)).reduce((a, v) => {
				if (!a[v.I.type.type]) {
					a[v.I.type.type] = {
						sites: '',
						type: v.I.type
					}
				}
				//const siteType = this.props.siteTypes.find(o => o.parameter === v.I.type.type)
				a[v.I.type.type].sites += `<div class='percel-link'>${ v.I.name } - ${ v.I.code }</div>`
				return a
			}, {})
			const content = Object.keys(featuresByType).map(k => {
				const p = featuresByType[k]
				return `<div class='sites-component'><h5 class='site-type-title'>${ p.type.title }</h5><div class='sites-component'>${ p.sites }</div></div>`
			}).join('')
			if (content && features.length) {
				const coords = features[0].getGeometry().getCoordinates()
				overlay.getElement().innerHTML = `<div class='popup-content'>${ content }</div>`
				overlay.setPosition(coords)
			}
		})

		const map = ReactDOM.findDOMNode(this.refs[this.props.idRef])
		this.olMap.setTarget(map)
		if (this.props.mapConf.extent && this.props.mapConf.extent.length === 4) {
			this.olMap.getView().fit(ol.proj.transformExtent(this.props.mapConf.extent, 'EPSG:4326', 'EPSG:3857'), this.olMap.getSize())
		}
		this.olMap.updateSize()
	}

	componentWillReceiveProps(nextProps) {
		const added = nextProps.layers.filter(next => {
			return !this.props.layers.find((prec) => prec === next)
		})
		added.forEach((element) => {
			this.olMap.addLayer(element.getLayer())
		}, this)

		const removed = this.props.layers.filter(prec => {
			return !nextProps.layers.find((next) => prec === next)
		})

		removed.forEach((element) => {
			this.olMap.removeLayer(element.getLayer())
		}, this)
		if (nextProps.mapConf.extent && !isEqual(nextProps.mapConf.extent, this.props.mapConf.extent)) {
			this.olMap.getView().fit(ol.proj.transformExtent(nextProps.mapConf.extent, 'EPSG:4326', 'EPSG:3857'), this.olMap.getSize())
			if (nextProps.mapConf.zoom != this.props.mapConf.zoom) {
				this.olMap.getView().setZoom(nextProps.mapConf.zoom)
			}
		} else if (nextProps.mapConf.zoom != this.props.mapConf.zoom) {
			this.olMap.getView().setCenter(ol.proj.fromLonLat(nextProps.mapConf.center))
			this.olMap.getView().setZoom(nextProps.mapConf.zoom)
		}
		if (!isEqual(nextProps.hover, this.props.hover)) {
			this.removeFeatures(this.hover)
			if (this.layers && this.layers[nextProps.hover.type]) {
				const point = this.layers[nextProps.hover.type].getSource().getFeatures().find(f => f.get('id') === nextProps.hover.id)
				if (point) {
					const hoverFeature = new ol.Feature({
						geometry: point.getGeometry()
					})
					hoverFeature.setStyle(SiteTypes.createIconStyleHover(SiteTypes[nextProps.hover.type].icon))
					this.hover.getSource().addFeature(hoverFeature)
					//point.setStyle(SiteTypes.createIconStyleHover(SiteTypes[nextProps.hover.type].icon))
				}
			}
		} else {
			this.olMap.removeOverlay(this.overLay)
		}
		if (this.props.layers !== nextProps.layers) {
			this.olMap.getLayers().forEach(l => {
				const type = l.get('type')
				if (l.get('id') === 'points' && type && type.type) {
					this.layers[type.type] = l
				}
			})
		}
		this.olMap.updateSize()
	}

	componentDidUpdate(prevProps) {
		if (prevProps.visualisation !== this.props.visualisation) {
			this.setVisualisationsLayers(prevProps)
		}
		this.olMap.updateSize()
	}

	removeFeatures(layer) {
		layer.getSource().getFeatures().forEach(f => {
			layer.getSource().removeFeature(f)
		})
	}

	/*createMeasureTooltip = () => {
		if (this.measureTooltipElement) {
			this.measureTooltipElement.parentNode.removeChild(this.measureTooltipElement)
		}
		this.measureTooltipElement = document.createElement('div')
		this.measureTooltipElement.className = 'tooltip tooltip-measure'
		this.measureTooltip = new ol.Overlay({
			element: this.measureTooltipElement,
			offset: [0, -15],
			positioning: 'bottom-center'
		})
		this.olMap.addOverlay(this.measureTooltip)
	}*/


	clickMap(e) {
		e.preventDefault()
		/*if (this.props.visualisation === PANEL_CITY) {
			this.setState({ event: { clientX: e.clientX, clientY: e.clientY } })
			if (this.props.event) {
				const coordinate = this.olMap.getCoordinateFromPixel(this.olMap.getEventPixel({
					clientX: e.clientX,
					clientY: e.clientY
				}))
				const pointTransform = ol.proj.transform(coordinate, 'EPSG:3857', 'EPSG:4326')
				this.props.event(pointTransform, this.state.zoom)
			}
		}*/

		if (this.props.event) {
			const coordinate = this.olMap.getCoordinateFromPixel(this.olMap.getEventPixel({
				clientX: e.clientX,
				clientY: e.clientY
			}))
			const pointTransform = ol.proj.transform(coordinate, 'EPSG:3857', 'EPSG:4326')
			this.props.event(pointTransform, this.olMap.getView().getZoom())
		}
	}

	render() {
		return this.props.connectDropTarget(
			<div>
				<div ref={ this.props.idRef } id='map' style={ { height: this.props.mapConf.size + 'px' } }
					 onClick={ this.clickMap }>
					{ this.props.legends.map(b => {
						const { id, left, top, content } = b
						return (
							<BoxDustbin key={ id } id={ id } left={ left }
										top={ top } hideSourceOnDrag={ true }>
								{ content }
							</BoxDustbin>
						)
					}) }
					{ /* <Popup olMap={ this.olMap } layers={ this.props.layers } event={ this.state.event }
    					   popupProps={ this.state.popup }/> */ }
				</div>
				<div className='arrow_box ol-popup' id='popup-container'/>
			</div>
		)
	}

}

Map.propTypes = {
	layers: PropTypes.arrayOf(PropTypes.object),
	mapConf: PropTypes.shape({
		size: PropTypes.number,
		center: PropTypes.array,
		zoom: PropTypes.number,
		extent: PropTypes.arrayOf(PropTypes.number)
	}),
	event: PropTypes.func,
	drawFunction: PropTypes.bool,
	radius: PropTypes.func,
	hover: PropTypes.instanceOf(HoverDto),
	idRef: PropTypes.string,
	visualisation: PropTypes.string,
	legends: PropTypes.arrayOf(PropTypes.instanceOf(LegendDto)),
	siteTypes: PropTypes.arrayOf(PropTypes.instanceOf(DtoType)),
	connectDropTarget: PropTypes.func.isRequired
}

Map.defaultProps = {
	mapConf: {
		size: 300,
		center: [47.123010186224576, -1.820669934399723],
		zoom: 10,
		extent: null
	},
	layers: [],
	drawFunction: false,
	event: () => {
	},
	radius: () => {
	},
	idRef: 'map',
	visualisation: PANEL_CITY
}

const mapStateToProps = store => {
	return {
		visualisation: store.SitesReducer.visualisation,
		hover: store.SitesReducer.hover,
		siteTypes: store.ReferentialReducer.siteTypes,
		legends: store.AdministrationReducer.legends
	}
}

const boxTarget = {
	drop(props, monitor, component) {
		const moveBox = box => {
			const delta = monitor.getDifferenceFromInitialOffset()
			if (delta) {
				const left = Math.round(box.left + delta.x)
				const top = Math.round(box.top + delta.y)
				component.moveBox(box.id, left, top, box.children)
			} else {
				component.removeBox(box.id)
			}
		}

		const item = monitor.getItem()
		if (item.id && item.left && item.top) {
			moveBox(item)
		} else if (item.boxes && item.boxes.length) {
			item.boxes.forEach(b => moveBox(b))
		}
	}
}

const collect = dndConnect => {
	return {
		connectDropTarget: dndConnect.dropTarget()
	}
}

const dropTarget = DropTarget([ItemTypes.BOX, ItemTypes.DUSTBIN_BOX], boxTarget, collect)(Map)

export default connect(mapStateToProps)(dropTarget)



// WEBPACK FOOTER //
// ./src/utils/mapUtils/Map.js